var _defs, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    version: 1.1,
    viewBox: "0 0 190.7 147.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: -452.3,
    cy: -881.5,
    r: 77.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    "data-name": "Base Circle",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -20.3,
    cy: -892.5,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 658.2,
    cy: -892.5,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 876.7,
    cy: -892.5,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.7,
    cy: -892.5,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -472.3,
    cy: -891.5,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.2,
    cy: -897.5,
    r: 77.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -244.3,
    cy: -892.5,
    r: 77.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.5,141.8c35.2-31.8,71.8-81.1,102.9-117.7-7-5-14-9.9-21-14.9-1.2-.9-2.6-1.7-4.1-1.6-1.3.1-2.3,1.3-3.2,2.3-25.3,29.1-47.2,69.5-76.7,94.4-1.6,1.3-3.3,2.6-5.3,2.6-1.8,0-3.4-1.3-4.8-2.4-6.2-5.2-10.8-12.2-17-17.4-3.1-2.7-5.3-3.9-7.3-3.9-3.5-.1-6,3.2-10.1,8.1-3.6,4.2-7.8,7.7-11.3,11.9,14.6,9.4,33.9,28.9,48.5,38.3,1.6,1.1,3.5,2.2,5.4,2.1,1.5-.3,3-.8,4-1.7"
  })));
};
export default __webpack_public_path__ + "static/media/submit-check.8ec4342a.svg";
export { SvgComponent as ReactComponent };